import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useNavigationType } from 'react-router-dom';

import { APP_URL_CHAT, STORAGE_KEY_SELF_CREATED_CHAT } from '../../../const';
import storageService from '../../../service/StorageService';
import {
    getActiveChatState,
    setUpdateRemoveChatModal,
    startChatWithAdvisor,
    startChatWithAdvisorByActivities,
    startNewChat
} from '../../../store/slices/chatsSlice';
import Spinner from '../Spinner';
import styles from './styles.module.scss';

export const createChatBtnType = {
    advisorWidget: 'advisorWidget',
    advisorLanding: 'advisorLanding',
    default: 'default'
};

const CreateNewChat = ({ label = '', type = createChatBtnType.default, advisorAlias = 'veda', activityId = null, isActivity = false }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const navigationType = useNavigationType();
    const { loading } = useSelector(getActiveChatState);

    const startChatByAlias = async () => {
        dispatch(setUpdateRemoveChatModal({ isOpen: false, alias: null }));
        return dispatch(startChatWithAdvisor(`alias/${advisorAlias}`)).then((result) => result);
    };

    const startChatByActivity = async () => {
        if (!activityId) {
            return;
        }
        return dispatch(startChatWithAdvisorByActivities(activityId)).then((result) => result);
    };

    const startChatById = async () => {
        return dispatch(startNewChat()).then((result) => result);
    };

    const startChatFn = type !== createChatBtnType.default ? (isActivity ? startChatByActivity : startChatByAlias) : startChatById;

    const onChatClick = () => {
        if (loading) {
            return;
        }
        startChatFn()
            .then((result) => {
                if (result?.meta?.requestStatus === 'fulfilled') {
                    storageService.add(STORAGE_KEY_SELF_CREATED_CHAT, result?.payload?.id);
                    navigate(`/${APP_URL_CHAT}/${result?.payload?.advisor?.alias}/${result?.payload?.id}`);
                }
            })
            .catch((error) => {
                console.log(error);
                if (type === createChatBtnType.advisorWidget) {
                    navigate(`/${APP_URL_CHAT}/${advisorAlias}`);
                    return;
                }
            });
    };

    const handleBackToWidget = () => {
        window.removeEventListener('popstate', handleBackToWidget);
        window.history.go(-1);
    };

    useEffect(() => {
        if (type === createChatBtnType.advisorWidget && navigationType.toString() === 'REPLACE') {
            window.addEventListener('popstate', handleBackToWidget);
            onChatClick();
        }
    }, []);

    return type === createChatBtnType.advisorWidget ? (
        loading ? (
            <Spinner width={224} height={224} />
        ) : null
    ) : (
        <button className={classNames('home-Button', styles.btn)} onClick={onChatClick}>
            {loading ? (
                <div className={styles.spinner}>
                    <Spinner fill={'#000000'} width={30} height={30} />
                </div>
            ) : (
                <>{!!label ? label : t('labels.startChat')}</>
            )}
        </button>
    );
};

export default CreateNewChat;
